<script>
    import store from "../../store";
    import Errors from "../../helpers/Errors";

    import Modal from "../Modal";
    import PackagePanel from "../onboarding/PackagePanel";
    import PostcodeFinder from '../PostcodeFinder';

    export default {
        name: "SetupPaymentForm",

        props: {
            'errorMessages': {
                required: false
            }
        },

        components: {
            PackagePanel,
            PostcodeFinder,
            Modal
        },

        data() {
            return {
                fields: {
                    account_name: '',
                    payment_type: '',
                    dd_in_my_name: null,
                    dd_only_me: null,
                    address: {}
                },
                errors: new Errors(JSON.parse(this.errorMessages)),
                show_modal: false
            }
        },
        computed: {
            dd: function () {
                return {
                    in_my_name: this.fields.dd_in_my_name === false ? false : null,
                    only_me: this.fields.dd_only_me === false ? false : null,
                }
            }
        }
    }
</script>
